import { SUP_PAYMENT_METHODS } from '@/enum/payments.ts'
import axios from 'axios'
import { getI18n } from '@/plugins/i18n.ts'
import type { Prettify } from '@/types/Utilities.ts'

export const getSubPaymentMethodName = (method: number) => {
  return Object
    .entries(SUP_PAYMENT_METHODS)
    .find(([, value]) => value === method)
    ?.[0]?.toLowerCase() as Prettify<keyof typeof SUP_PAYMENT_METHODS>
}

export const handlePaymentErrors = (error: unknown) => {
  const i18n = getI18n()
  const t = i18n.global.t

  let errorMessage = t('something_went_wrong')
  if (axios.isAxiosError(error)) {
    if (error.response?.status === 422) {
      errorMessage = t('payment.errors.validation_failed', { error: error.response?.data?.message })
    } else if (error.response?.status === 401) {
      errorMessage = t('payment.errors.unauthorized', { error: error.response?.data?.errors })
    } else if (error.response?.status === 403) {
      errorMessage = t('payment.errors.forbidden', { error: error.response?.data?.errors })
    } else if (error.response?.status === 429) {
      errorMessage = t('payment.errors.rate_limit', { error: error.response?.data?.errors })
    } else if (error?.response?.status && error?.response?.status >= 500) {
      errorMessage = t('payment.errors.server_error', { error: error.response?.data?.errors })
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message
    } else if (error.message) {
      errorMessage = error.message
    }
  } else if (error instanceof Error) {
    errorMessage = error.message
  } else if (typeof error === 'string') {
    errorMessage = error
  } else if (error && typeof error === 'object' && 'message' in error) {
    errorMessage = error.message as string
  }

  return errorMessage
}
